module.exports = __webpack_public_path__ + "static/prottaslogo-99894f6e6d1f42f5a197a2ea659c590f.svg";